import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'react-bootstrap-5';

import WysiwygEditor from 'components/form/wysiwyg_editor';

class SectionModal extends React.Component {
  static propTypes = {
    customTables: PropTypes.array.isRequired,
    layout: PropTypes.string,
    section: PropTypes.object,
    sectionTypes: PropTypes.array.isRequired,
    shown: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      section: { ...props.section }
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.shown && this.props.shown) {
      this.setState({
        section: { ...this.props.section }
      });
    }
  }

  handleEditorChange = (content) => {
    this.setState(({ section }) => ({ section: { ...section, content } }));
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((state) => {
      const section = { ...state.section, [name]: value };
      if (value === "custom_table" && section.customFieldSlug == null) {
        section.customFieldSlug = this.props.customTables[0].value;
      }
      return { section };
    });
  };

  saveSection = () => {
    if (!this.state.section || !this.state.section.sectionType) {
      return;
    }

    const section = { ...this.state.section };
    if (this.state.section.sectionType !== "custom_table") {
      section.customFieldSlug = null;
    }
    if (!["custom_table", "custom_paragraph"].includes(this.state.section.sectionType)) {
      section.title = null;
      section.content = null;
    }
    if (this.state.section.sectionType !== "custom_button") {
      section.buttonUrl = null;
      section.buttonText = null;
    }

    this.props.onSuccess(section);
  };

  render() {
    return (
      <Modal backdrop={true} keyboard={true} show={this.props.shown} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{this.renderHeader()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Section Type</Form.Label>
            <Form.Select
              name="sectionType"
              value={this.state.section.sectionType || ''}
              onChange={this.handleChange}
            >
              {this.renderSectionTypes()}
            </Form.Select>
          </Form.Group>
          {this.renderCustomTableInput()}
          {this.renderCustomParagraphInput()}
          {this.renderCustomButtonInput()}
        </Modal.Body>
        <Modal.Footer>
          <Button name="btn-cancel" type="button" variant="secondary" onClick={this.props.onHide}>Cancel</Button>
          <Button name="btn-save" type="button" variant="primary" onClick={this.saveSection}>Save Section</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderHeader() {
    return this.state.section.id == null ? "New Section" : "Edit Section";
  }

  renderSectionTypes() {
    return this.props.sectionTypes.map((type) => {
      if (type.key === 'custom_table' && this.props.customTables.length === 0) return null;
      if (type.validLayouts && !_.includes(type.validLayouts, this.props.layout)) return null;
      return <option key={type.id} value={type.key}>{type.label}</option>;
    });
  }

  renderCustomTableInput() {
    if (this.state.section.sectionType !== 'custom_table') {
      return null;
    }

    const customTableOptions = this.props.customTables.map(table => (
      <option key={table.key} value={table.value}>{table.label}</option>
    ));

    return (
      <div>
        <Form.Group className="mb-3">
          <Form.Label>Custom Table</Form.Label>
          <Form.Select
            name="customFieldSlug"
            value={this.state.section.customFieldSlug || this.props.customTables[0].value}
            onChange={this.handleChange}
          >
            {customTableOptions}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control
            name="title"
            type="text"
            value={this.state.section.title || ""}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Table Subtext</Form.Label>
          <Form.Control
            as="textarea"
            name="content"
            value={this.state.section.content || ""}
            onChange={this.handleChange}
          />
        </Form.Group>
      </div>
    );
  }

  renderCustomParagraphInput() {
    if (this.state.section.sectionType !== 'custom_paragraph') return;

    return (
      <div>
        <Form.Group className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control
            name="title"
            type="text"
            value={this.state.section.title || ""}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Paragraph</Form.Label>
          <WysiwygEditor
            content={this.state.section.content}
            name="content"
            onChange={this.handleEditorChange}
          />
        </Form.Group>
      </div>
    );
  }

  renderCustomButtonInput() {
    if (this.state.section.sectionType !== 'custom_button') return;

    return (
      <div>
        <Form.Group className="mb-3">
          <Form.Label>Button URL</Form.Label>
          <Form.Control
            name="buttonUrl"
            type="text"
            value={this.state.section.buttonUrl || ""}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Button Text</Form.Label>
          <Form.Control
            name="buttonText"
            type="text"
            value={this.state.section.buttonText || ""}
            onChange={this.handleChange}
          />
        </Form.Group>
      </div>
    );
  }
}

export default SectionModal;
